import { observer } from 'mobx-react';
import { useContext, useEffect } from 'react';
import { appContext } from '@utils';
import { useParams } from 'react-router-dom';
import { OrganizationBillingHeader } from "./OrganizationBillingHeader";
import { OrganizationBillingTable } from "./OrganizationBillingTable";

export const OrganizationBillingComponent = observer(() => {
  const {
    organizationStore: { fetchOrganization, resetOrganizationInContext },
    billingStore: { getInvoices, getOrganizationBilling },
    tiersStore: { getTiers },
  } = useContext(appContext);
  const { id } = useParams<any>();

  useEffect(() => {
    fetchOrganization(id);
    getInvoices(id);
    getOrganizationBilling(id);
    getTiers();
  }, [fetchOrganization, id, getInvoices, getOrganizationBilling, getTiers]);

  useEffect(() => resetOrganizationInContext, [resetOrganizationInContext]);

  return (
    <>
      <OrganizationBillingHeader />
      <OrganizationBillingTable />
    </>
  )
});
